"use client";

import { c as _c } from "react/compiler-runtime";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import { buildMemesQuickVoteApiDrop, deriveMemesQuickVoteStatsFromDrop } from "@/hooks/memesQuickVote.helpers";
import { useMemesQuickVoteContext } from "@/hooks/useMemesQuickVoteContext";
import { fetchMemesQuickVoteSummary, getMemesQuickVoteSummaryQueryKey } from "@/hooks/memesQuickVote.query";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
export const useMemesQuickVoteSummary = t0 => {
  const $ = _c(25);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const {
    contextProfile,
    isEnabled,
    memesWaveId,
    proxyId
  } = useMemesQuickVoteContext();
  const waveId = typeof memesWaveId === "string" && memesWaveId.length > 0 ? memesWaveId : null;
  let t3;
  if ($[2] !== contextProfile || $[3] !== proxyId || $[4] !== waveId) {
    t3 = getMemesQuickVoteSummaryQueryKey({
      contextProfile,
      proxyId,
      waveId
    });
    $[2] = contextProfile;
    $[3] = proxyId;
    $[4] = waveId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const queryKey = t3;
  const t4 = enabled && isEnabled && waveId !== null;
  let t5;
  if ($[6] !== waveId) {
    t5 = () => fetchMemesQuickVoteSummary(waveId);
    $[6] = waveId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getDefaultQueryRetry();
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== queryKey || $[10] !== t4 || $[11] !== t5) {
    t7 = {
      queryKey,
      enabled: t4,
      queryFn: t5,
      staleTime: 60000,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      ...t6
    };
    $[9] = queryKey;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const query = useQuery(t7);
  query.data?.drops;
  query.data?.wave;
  let t8;
  bb0: {
    const drop = query.data?.drops[0];
    const wave = query.data?.wave;
    if (!drop || !wave) {
      t8 = null;
      break bb0;
    }
    let t9;
    if ($[13] !== drop || $[14] !== wave) {
      t9 = buildMemesQuickVoteApiDrop(drop, wave);
      $[13] = drop;
      $[14] = wave;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t8 = t9;
  }
  const firstDrop = t8;
  const count = query.data?.count ?? 0;
  let t9;
  if ($[16] !== count || $[17] !== firstDrop) {
    t9 = deriveMemesQuickVoteStatsFromDrop({
      count,
      drop: firstDrop
    });
    $[16] = count;
    $[17] = firstDrop;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const stats = t9;
  let t10;
  if ($[19] !== count || $[20] !== firstDrop || $[21] !== isEnabled || $[22] !== query || $[23] !== stats) {
    t10 = {
      ...query,
      count,
      firstDrop,
      isQuickVoteEnabled: isEnabled,
      stats
    };
    $[19] = count;
    $[20] = firstDrop;
    $[21] = isEnabled;
    $[22] = query;
    $[23] = stats;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};